import Service from '@ember/service';

export const CONVERSATION_ACTIVITY_EVENTS = {
  REPLACE: 'conversation:replace',
  DESTROYED: 'conversation:destroyed',
};

/**
 * Internal pub/sub event bus decoupling websocket activity handlers from domain reactor services.
 */
export default class MessagingInternalEventsService extends Service {
  #listenersByEvent = new Map();

  on(eventName, listener) {
    const listeners = this.#listenersByEvent.get(eventName) ?? new Set();
    listeners.add(listener);
    this.#listenersByEvent.set(eventName, listeners);
  }

  off(eventName, listener) {
    this.#listenersByEvent.get(eventName)?.delete(listener);
  }

  emit(eventName, payload) {
    const listeners = this.#listenersByEvent.get(eventName);
    if (!listeners) {
      return;
    }

    for (const listener of [...listeners]) {
      listener(payload);
    }
  }
}
